import { Lesson } from "../../../grades/types";
import { Resource, Time } from "../../../shared/types";

export type Offer = {
  id: number;
  name: string;
  description?: string;
  image?: Resource;
  startsAt?: Time;
  endsAt?: Time;
  price: number;
  oldPrice: number;
  salePercentage: number;
  lessons: Lesson[];
  isPurchased?: boolean;
  isFree?: boolean;
  status?: OfferStatus;
};

export enum OfferStatus {
  New = "new",
  Pending = "pending",
  Purchased = "purchased",
  Failed = "failed",
  Expired = "expired",
  NotStarted = "notStarted",
}
